import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const PackageStructurePageRBAC = {
  pageID: '693790371d063f5c54da1fd1ebe10879',
  elementID: {
    BtnCreate: 'eb09d851b36d7745b073f0d5f32c9e8b',
    BtnUpdate: '4d6bf0628e6d7745b073ca38d4cc5bb8',
    BtnDelete: '118956ae876d7745b073fa9050ee5012',
    BtnUpdateSellingType: '6df0d01fa9a29728cb3c6a756a81a2ec',
  },
} as const

export const useRBACPackageStructurePage = createUseRBAC(PackageStructurePageRBAC.elementID)

export type UseRBACPackageStructurePageType = ReturnType<typeof useRBACPackageStructurePage>
